import { Alert } from '@mui/material';

// Premiums typed over by hand in the Quotation Preview carry `edited: true` until the plan's
// premiums are replaced by freshly fetched rates.
export function isPlanManuallyEdited(quotations, plan) {
    if (!plan) return false;
    const matchesPlan = p => plan.uid ? p.plan_uid === plan.uid : p.plan_id === plan.plan_id;
    return (quotations || []).some(quotation =>
        (quotation.client_premiums || []).some(cp => (cp.premiums || []).some(p => matchesPlan(p) && p.edited))
    );
}

// Only rates fetched through View Rates replace the manual edits: an edit dialog starts from
// the premiums already in the quotation, so updating without re-fetching writes the edited
// values straight back and they stay marked as edited.
export function withFreshRatesFlag(updates, fetchedFreshRates) {
    if (!fetchedFreshRates) return updates;
    return updates.map(update => ({ ...update, premium: { ...update.premium, edited: false } }));
}

export function ManualEditNotice({ quotations, editingPlan }) {
    if (!isPlanManuallyEdited(quotations, editingPlan)) return null;
    return (
        <Alert severity="warning" sx={{ mt: 2 }}>
            The premiums have been edited manually.
        </Alert>
    );
}
